import { Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { ContainerProps } from '@mui/material';

const useStyles = makeStyles({ name: 'HomeSection' })((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      '&:first-of-type > div': {
        paddingTop: 0,
      },
    },
  },
  container: {
    padding: theme.spacing(4, 2),

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 2),
      maxWidth: `calc(${theme.breakpoints.values.lg} + ${theme.spacing(2)})`,
    },
  },
}));

type HomeSectionProps = ContainerProps & {
  readonly rootClassName?: string;
};

export const HomeSection: React.FC<HomeSectionProps> = ({
  children, rootClassName = '', className = '', ...restProps
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, rootClassName)}>
      <Container
        className={cx(classes.container, className)}
        maxWidth="lg"
        {...restProps}
      >
        {children}
      </Container>
    </div>
  );
};
